module.exports = __webpack_public_path__ + "img/denic.b14021bd.png";